import { render } from "./GroupSelectionEditItemPane.vue?vue&type=template&id=6d0f9167&scoped=true&ts=true"
import script from "./GroupSelectionEditItemPane.vue?vue&type=script&lang=ts"
export * from "./GroupSelectionEditItemPane.vue?vue&type=script&lang=ts"

import "./GroupSelectionEditItemPane.vue?vue&type=style&index=0&id=6d0f9167&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0f9167"]])

export default __exports__